module.exports = __webpack_public_path__ + "static/media/ICBT 2a.35584337.jpg";